import { key } from '@connect-x-app/shared-test-ids';

export const APP_CONFIG_TEST_IDS = {
  about: {
    licenseItem: (name: string) => `appConfig.about.view.licenseItem.${key(name)}`,
    licenses: 'appConfig.about.scrollView.licenses',
    repository: 'appConfig.about.button.repository',
  },
  settings: {
    allowPushNotifications: 'appConfig.settings.switch.allowPushNotifications',
    allowPushNotificationsRow: 'appConfig.settings.view.allowPushNotifications',
    group: (group: string) => `appConfig.settings.button.group.${key(group)}`,
    itemToggle: (name: string) => `appConfig.settings.switch.${key(name)}`,
    pushNotifications: 'appConfig.settings.view.pushNotifications',
    setting: (name: string) => `appConfig.settings.view.${key(name)}`,
  },
} as const;
